/* eslint-disable camelcase */
import qs from 'qs';
// IE has no window.location.origin
export const getOrigin = (windowObj) =>
  `${windowObj.location.protocol}//${windowObj.location.hostname}\
${windowObj.location.port ? `:${windowObj.location.port}` : ''}`;

export const getQueryString = (windowObj) => windowObj.location.search;

export const getRawRedirectUri = (windowObj) =>
  encodeURIComponent(
    qs.parse(getQueryString(windowObj), { ignoreQueryPrefix: true }).next,
  );

export const getQueryParams = (windowObj) =>
  qs.parse(getQueryString(windowObj), { ignoreQueryPrefix: true });

export const getAuthQueryParams = (windowObj) => {
  const { code, error, error_description } = getQueryParams(windowObj);
  return {
    code,
    error,
    description: error_description,
  };
};

export const redirect = (windowObj, next) => {
  if (next) {
    windowObj.location.replace(next);
  }
};

export const getRedirectUri = (windowObj) => {
  const parsedRedirectUri = qs.parse(getQueryString(windowObj), {
    ignoreQueryPrefix: true,
  }).next;
  return parsedRedirectUri ? decodeURIComponent(parsedRedirectUri) : undefined;
};

export const redirectFromQueryString = (windowObj) => {
  redirect(windowObj, getRedirectUri(windowObj));
};
